import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SharedService } from '../shared/shared.service';
import { AuthenticationService } from '../shared/_helpers/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { OrganizationsService } from '../organizations/organizations.service';

@Component({
    selector: 'app-app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.css'],
    standalone: false
})
export class AppLayoutComponent implements OnInit, AfterViewChecked {

  public componentTitle = 'ToDo::';
  public routerLinkArray = [];
  public icons: { [name: string]: any } = {
    'faArrowLeft': faArrowLeft
  };
  public orgName: string;

  private _orgNames: {};
  constructor(private _authenticationService: AuthenticationService, public translate: TranslateService,
    private _sharedService: SharedService, private _organizationsService: OrganizationsService,
    private _translateService: TranslateService, private _cdRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    const userData = this._authenticationService.currentUserDataValue;
    if (userData.accountType === 1) {
      this.routerLinkArray = ['counter', userData.orgId];
    } else {
      this.routerLinkArray = ['/'];
    }

    console.log(userData.orgId);
    if (userData.orgId) {
      const currentLang = this._translateService.currentLang;

      this._organizationsService.getOrganization(userData.orgId.toString()).subscribe(result => {
        if (result) {
          console.log(result);
        }
      });
      this._sharedService.organizationNameSubject.subscribe(result => {
        if (result) {
          this.orgName = result[currentLang];
          this._orgNames = result;
          this._translateService.onLangChange.subscribe(newLang => {
            this.orgName = this._orgNames[newLang.lang];
          });
        } else {
          this.orgName = undefined;
        }
      });
    }
  }

  ngAfterViewChecked() {
    const currentLang = this._translateService.currentLang;
    this._sharedService.organizationNameSubject.subscribe(result => {
      if (result) {
        this.orgName = result[currentLang];
        this._orgNames = result;
        this._translateService.onLangChange.subscribe(newLang => {
          this.orgName = this._orgNames[newLang.lang];
        });
      } else {
        this.orgName = undefined;
      }
    });
    this._cdRef.detectChanges();
  }

  onLogout() {
    this._authenticationService.logout();
  }

  onLanguageChangeClick(lang) {
    this.translate.use(lang);
    localStorage.setItem('userDataLang', lang);
  }

}
